const maxAllowedCharsForFolderName = 200;

export default maxAllowedCharsForFolderName;
